export class CatalogCheckboxGroup {
	private readonly elements: NodeListOf<Node>;

	constructor(elements: NodeListOf<Node>) {
		if (!elements) return;
		this.elements = elements;
		this.init();
	}

	private handleChange = ({ target }) => {
		if (!target.checked) return;
		Array.from(this.elements)
			.filter((element) => element.dataset.group === target.dataset.group)
			.filter((element) => element !== target)
			.forEach((element) => element.checked = false);
	};

	init = () => {
		this.elements.forEach((element) => element.addEventListener('change', this.handleChange));
	};
}
